// @ts-nocheck
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap-v5";
import Select from 'react-select';
import { ToastContainer } from 'react-toastify';
import DailySalesReport from '../components/DailySalesReport';
import EmployeeWiseSalesReport from '../components/EmployeeWiseSalesReport';
import YearlySalesGradeReport from '../components/YearlySalesGradeReport';
import SkuWiseSalesReport from '../components/SkuWiseSalesReport';
import CustomerTransactionReport from '../components/CustomerTransactionReport';
import GradeWiseSalesReport from '../components/GradeWiseSalesReport';
import AreaWiseProductSalesReport from '../components/AreaWiseProductSalesReport';
import MisDashboardReport from '../components/MisDashboardReport';
import GetPagePermission from "../components/GetPagePermission";
import { useLocation } from "react-router-dom";

export default function MisReports() {

    const hasDailySalesReportPermission = GetPagePermission("/daily-sales-report");
    const hasEmployeeWiseSalesReportPermission = GetPagePermission("/employee-wise-sales-report");
    const hasYearlySalesGradeReportPermission = GetPagePermission("/yearly-sales-grade-report");
    const hasYearlyQuantityGradeReportPermission = GetPagePermission("/yearly-quantity-grade-report");
    const hasYearlyGradeReportPermission = hasYearlySalesGradeReportPermission || hasYearlyQuantityGradeReportPermission;
    const hasSkuWiseSalesReportPermission = GetPagePermission("/sku-wise-sales-report");
    const hasCustomerTransactionReportPermission = GetPagePermission("/customer-transaction-report");
    const hasGradeWiseSalesReportPermission = GetPagePermission("/grade-wise-sales-report");
    const hasAreaWiseProductSalesReportPermission = GetPagePermission("/area-wise-product-sales-report");

    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const [currentReport, setCurrentReport] = useState({ label: 'Select a Report', value: '' });
    const [availableReports, setAvailableReports] = useState([{ label: 'Select a Report', value: '' }]);

    useEffect(() => {
        const updatedReports = [{ label: 'Select a Report', value: '' }];

        if (hasDailySalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Daily Sales Report', value: 'dailySalesReport' });
        }

        if (hasEmployeeWiseSalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Employee Wise Sales Report', value: 'employeeWiseSalesReport' });
        }

        if (hasYearlyGradeReportPermission) {
            updatedReports.push({ label: 'Sales >> Monthly Sales Report', value: 'yearlySalesGradeReport' });
        }

        if (hasSkuWiseSalesReportPermission) {
            updatedReports.push({ label: 'Sales >> SKU Wise Sales Report', value: 'skuWiseSalesReport' });
        }

        if (hasCustomerTransactionReportPermission) {
            updatedReports.push({ label: 'Sales >> Customer Transaction Report', value: 'customerTransactionReport' });
        }

        if (hasGradeWiseSalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Grade Wise Sales Report', value: 'gradeWiseSalesReport' });
        }

        if (hasAreaWiseProductSalesReportPermission) {
            updatedReports.push({ label: 'Sales >> Area Wise Product Sales Report', value: 'areaWiseProductSalesReport' });
        }

        updatedReports.push({ label: 'Sales >> MIS Dashboard', value: 'misDashboard' });

        updatedReports.sort((a, b) => a.label.localeCompare(b.label));
        setAvailableReports(updatedReports);
        // eslint-disable-next-line
    }, [hasDailySalesReportPermission, hasEmployeeWiseSalesReportPermission, hasYearlyGradeReportPermission, hasSkuWiseSalesReportPermission, hasCustomerTransactionReportPermission, hasGradeWiseSalesReportPermission, hasAreaWiseProductSalesReportPermission]);

    useEffect(() => {
        if (query.get('type') === 'dailySalesReport') {
            setCurrentReport({ label: 'Sales >> Daily Sales Report', value: 'dailySalesReport' });
        }

        if (query.get('type') === 'employeeWiseSalesReport') {
            setCurrentReport({ label: 'Sales >> Employee Wise Sales Report', value: 'employeeWiseSalesReport' });
        }

        if (query.get('type') === 'yearlySalesGradeReport' || query.get('type') === 'yearlyQuantityGradeReport') {
            setCurrentReport({ label: 'Sales >> Monthly Sales Report (Grade)', value: 'yearlySalesGradeReport' });
        }

        if (query.get('type') === 'skuWiseSalesReport') {
            setCurrentReport({ label: 'Sales >> SKU Wise Sales Report', value: 'skuWiseSalesReport' });
        }

        if (query.get('type') === 'customerTransactionReport') {
            setCurrentReport({ label: 'Sales >> Customer Transaction Report', value: 'customerTransactionReport' });
        }

        if (query.get('type') === 'gradeWiseSalesReport') {
            setCurrentReport({ label: 'Sales >> Grade Wise Sales Report', value: 'gradeWiseSalesReport' });
        }

        if (query.get('type') === 'areaWiseProductSalesReport') {
            setCurrentReport({ label: 'Sales >> Area Wise Product Sales Report', value: 'areaWiseProductSalesReport' });
        }

        if (query.get('type') === 'misDashboard') {
            setCurrentReport({ label: 'Sales >> MIS Dashboard', value: 'misDashboard' });
        }
        // eslint-disable-next-line
    }, [query.get('type')]);

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className="card-title">
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            MIS Report Viewer
                        </span>
                    </div>
                </div>
                <div className='card-body pt-0'>
                    <Row>
                        <Col xs={8} md={10} lg={10}>
                            <Select
                                className="form-select-sm"
                                value={currentReport}
                                onChange={(e: any) => setCurrentReport(e)}
                                options={availableReports}
                                menuPosition="fixed"
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Col>
                        <Col xs={4} md={2} lg={2} className={"form-control-sm ps-0"}>
                            <button type="button" className="btn btn-primary btn-sm w-100 h-100">Generate</button>
                        </Col>
                    </Row>
                    <div className="mt-5">
                        {currentReport.value === 'dailySalesReport' && hasDailySalesReportPermission && <DailySalesReport />}
                        {currentReport.value === 'employeeWiseSalesReport' && hasEmployeeWiseSalesReportPermission && <EmployeeWiseSalesReport />}
                        {currentReport.value === 'yearlySalesGradeReport' && hasYearlyGradeReportPermission && <YearlySalesGradeReport />}
                        {currentReport.value === 'skuWiseSalesReport' && hasSkuWiseSalesReportPermission && <SkuWiseSalesReport />}
                        {currentReport.value === 'customerTransactionReport' && hasCustomerTransactionReportPermission && <CustomerTransactionReport />}
                        {currentReport.value === 'gradeWiseSalesReport' && hasGradeWiseSalesReportPermission && <GradeWiseSalesReport />}
                        {currentReport.value === 'areaWiseProductSalesReport' && hasAreaWiseProductSalesReportPermission && <AreaWiseProductSalesReport />}
                        {currentReport.value === 'misDashboard' && <MisDashboardReport />}
                        <ToastContainer />
                    </div>
                </div>
            </div>
        </>
    );
}
